import cookies from 'js-cookie'

export default function getGeoInfo(req) {
  if (req) return req.cookies.geoInfoSpoof || req.cookies.geoInfo || {}

  return cookies.getJSON('geoInfoSpoof') || cookies.getJSON('geoInfo') || {}
}

export function getCountryCode(req) {
  const geoInfo = getGeoInfo(req)
  if (geoInfo) return geoInfo.countryCode
  return null
}
